module.exports = __webpack_public_path__ + "static/media/link3.3d4b9258.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/link3.svg
// module id = 3124
// module chunks = 7